module.exports = __webpack_public_path__ + "static/img/产品中心-问煤-多源输入支持.ee521129.jpg";